import React from 'react'
import { styled } from '@the-platform-group/component-library'
import { AsyncSelect } from '@the-platform-group/component-library/Select'
import { ArrowDropDown as ArrowDropDownIcon } from '@the-platform-group/component-library/Icons'
import { debouncedLoadCustomers } from 'utils/optionsLoaders'

const StyledAsyncSelect = styled(AsyncSelect)(({ theme }) => ({
  '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
    paddingRight: `${theme.spacing(1.5)} !important`,
  },
  '& .MuiSelect-iconOutlined': {
    right: theme.spacing(4),
  },
  '& .MuiIconButton-root .MuiSvgIcon-root': {
    color: theme.palette.info.main,
  },
}))

const CustomerSelect = props => {
  const { optionsLoaderParams, includeCustomerType, activeCustomerOnly, ...rest } = props

  let params = { ...optionsLoaderParams }
  // Only add `type` param if we want to include specific types of customers (e.g. trial, customer, etc.)
  // Otherwise simply omit `type` param to include all customer types
  if (includeCustomerType !== 'all') {
    params.type = includeCustomerType || 'customer' // default type to "customer"
  }
  // If we only want active customers, include `state` param
  if (activeCustomerOnly) {
    params.state = 'active'
  }

  return (
    <StyledAsyncSelect
      id="customersFilter"
      placeholder="Search customers"
      variant="outlined"
      optionsLoader={term => debouncedLoadCustomers({ term, ...params })}
      InputProps={{
        endAdornment: <ArrowDropDownIcon sx={{ color: 'grey.600' }} />,
      }}
      {...rest}
    />
  )
}

export default CustomerSelect
